import actionFe from 'utils/mw/actionFe.util';

export const feClearOldAppointment = actionFe('feClearOldAppointment');
